<template>
  <div data-v-e14ef83e="" data-v-2ac6a5fc="" class="modifyEmail member">
    <form data-v-e14ef83e="">
      <div data-v-e14ef83e="" class="list">
        <div data-v-e14ef83e="" class="form-group">
          <label data-v-e14ef83e="">邮箱</label>
          <div data-v-e14ef83e="" class="input-group">
            <input data-v-e14ef83e="" v-model="email" type="text" placeholder="请输入邮箱地址" />
          </div>
        </div>
      </div>
      <p data-v-e14ef83e="">无法设置邮箱，<a data-v-e14ef83e="" @click="$parent.openKefu">联系客服</a></p>
      <a data-v-e14ef83e="" class="form-button" @click="isOk" >确定</a>
    </form>
  </div>
</template>
<script>
export default {
  name: 'modifyEmail',
  data() {
    return {email:null};
  },
  created() {
    let that = this;
    that.email = that.$store.state.userInfo.email;
  },
  methods: {
    isOk() {
      let that = this;
      let url = '/api/updateuserinfo';
      let info = {};
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));

      //邮箱
      info.email = that.email;
      info.mobile = userInfo.mobile;
      info.birthday = userInfo.birthday;
      let regEmail = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (!regEmail.test(that.email)) {
        that.$parent.showTost(0, '请输入正确邮箱');
        return;
      }

      that.$parent.showLoading();
      that.$apiFun.post(url, info).then(res => {
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        that.$parent.hideLoading();
        if (res.code == 200) {
          that.$parent.showTost(1, res.message);
          that.$parent.getUserInfos();
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-5622a567.d35079a5.css';
</style>



// WEBPACK FOOTER //
// src/components/main/modifyEmail.vue